import {
  Form, 
  ButtonGroup, 
  Button, 
} from 'reactstrap';
import './layout.css';

function VideoModelPageControls(props){
  const{
    VideoStartText,
    handleSetStartClick,
    VideoEndText,
    handleSetEndClick,
    NextStepText,
    handleNextClick,
    openMediaCapture,
    videoButtonText
  } = props;
  console.log("VideoModelPageControls with: ",  props);
  return (
    <>
    <Form className='instruct-control-container'>
      <ButtonGroup className='instruct-control-bar' size='lg'>
          <Button id='video-model-button' className='instruct-control-button' onClick={openMediaCapture}>{videoButtonText}</Button>
          <Button className='instruct-control-button' onClick={() => handleSetStartClick()}>{VideoStartText}</Button>
          <Button className='instruct-control-button' onClick={() => handleSetEndClick()}>{VideoEndText}</Button>
          <Button className='instruct-control-button' color='primary' onClick={() => handleNextClick()}>{NextStepText}</Button>
      </ButtonGroup>
    </Form>
    </>
  );
}

export {VideoModelPageControls};